import { apiGateway } from "@/shared/apiGateway";

const getClient = context => {
  return apiGateway
    .apiGatewayGET("api/portfolio/clients/")
    .then(data => {
      context.commit("set_client_contacts_listing", data.contacts);
      delete data.clientContacts;
      context.commit("set_site_listing", data.sites);
      delete data.sites;
      context.commit("set_client", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Client"], {
        root: true
      });
    });
};

const getSite = (context, siteId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/sites/" + siteId)
    .then(data => {
      context.commit("set_building_listing", data.buildings);
      delete data.buildings;
      context.commit("set_site", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Site"], {
        root: true
      });
    });
};

const getBuilding = (context, buildingId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/buildings/" + buildingId)
    .then(data => {
      context.commit("set_plant_listing", data.plants);
      delete data.plants;
      context.commit("set_building", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Building"], {
        root: true
      });
    });
};

const getPlant = (context, plantId) => {
  return apiGateway
    .apiGatewayGET("api/portfolio/plant/" + plantId)
    .then(data => {
      context.commit("set_plant", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Plant"], {
        root: true
      });
    });
};

export default {
  getClient,
  getSite,
  getBuilding,
  getPlant
};
